import React from 'react';

import { infocollectionTypes } from './actions'
import { nationalRegistryTypes } from '../national-registry/actions'
import { getPersonAge } from '../../utils'


const defaultCustomer = () => {
    let cust = {
        customerId: null,
        smokerstatus: "NonSmokerMin1Year",
        gender: '0',
        natRegGender: '0',
        occupation: null,
        education: null,
        confirm: false,
        LEBageByContractEnd: '65',
        LEBdeathbenefits: false,
        LEBpaymentfrequency: 'monthly',
        LEBdeathbenefitsbeneficiary: "0",
        LEBdeathbenefitsbeneficiaryOrgId: [],
        LEBtype: 'installments', // or insuranceamount
        LEBunits: 'percentage',
        LEBKDpercentage: 80,
        RENageByContractEnd: '65',
        RENdeathbenefits: false,
        RENtype: 'monthly',
        RENdeathbenefitsbeneficiary: "0",
        RENdeathbenefitsbeneficiaryOrgId: [],
        RENKDpercentage: 80,
        VIDemployeecontribution: 4.0,
        VIDemployercontribution: 2.0,
        VIDageByContractEnd: '67',
        VIDformerFund: '000',
        VIDonetime: false,
        VIDKDpercentage: 80,
        VIDTemployeecontribution: 0.0,
        VIDTemployercontribution: 3.5,
        VIDTageByContractEnd: '67',
        VIDTformerFund: '000',
        VIDTonetime: false,
        VIDThasconfirmedspecifiedprivatepension: false,
        VIDTKDpercentage: 80,
        KSPtype: 'installments', // or insuranceamount
        KSPageByContractEnd: '67',
        KSPpaymentfrequency: 'monthly',
        KSPdiseasepayment: '100',
        RISLEBtype: 'installments', // or insuranceamount
        RISLEBageByContractEnd: '65',
        RISLEBdeathbenefits: false,
        RISLEBpaymentfrequency: 'monthly',
        RISLEBdeathbenefitsbeneficiary: "0",
        RISLEBdeathbenefitsbeneficiaryOrgId: [],
        lebConfirm: false,
        renConfirm: false,
        forConfirm: false,
        rislebConfirm: false,
        kspConfirm: false,
        vidConfirm: false,
        vidtConfirm: false,
        risConfirm: false,
        RISriskgroup: '',
        RISpaymentfrequency: 'monthly',
        idStepConfirm: false,
        healthQuestionsConfirm: false,
        beneficiaryConfirm: false,
    }
    cust.VIDPortfolio = (window.KOMFORT_DYNAMIK_ENABLED ? 'komfortdynamik' : 'perspektive')
    cust.VIDTPortfolio = (window.KOMFORT_DYNAMIK_ENABLED ? 'komfortdynamik' : 'perspektive')
    cust.RENPortfolio = (window.KOMFORT_DYNAMIK_ENABLED ? 'komfortdynamik' : 'perspektive')
    cust.LEBPortfolio = (window.KOMFORT_DYNAMIK_ENABLED ? 'komfortdynamik' : 'perspektive')
    return cust
}

const initialState = {
    data: {}
}

export function infoCollection(state = initialState, action) {


    switch (action.type) {

        case infocollectionTypes.SET_KEY:

            state = { ...state }


            let customer = state.data[action.customerId]

            if (customer) {
                if (action.key !== undefined) {
                    customer[action.key] = action.value
                }

            } else {

                customer = defaultCustomer()
                customer.customerId = action.customerId

                if (action.key !== undefined) {
                    customer[action.key] = action.value
                }

                state.data[action.customerId] = customer
            }

            return state


        case infocollectionTypes.ADD_BENEFICIARY:

            state = { ...state }

            let _customer = state.data[action.customerId]

            if (_customer) {
                if (action.key !== undefined) {
                    _customer[action.key].push(action.value)
                }

            } else {
                _customer = defaultCustomer()
                _customer.customerId = action.customerId

                if (action.key !== undefined) {
                    _customer[action.key].push(action.value)
                }
                
            }

            state.data[action.customerId] = _customer

            return state
            

        case nationalRegistryTypes.RECEIVE:

            state = { ...state }

            if (action.onlyLookup !== true) {
                let c = null

                for (var person of action.data) {
                    c = state.data[person.NationalRegistry.OrgId]

                    let genderIncoming = ""+(+person.NationalRegistry.Gender + 1)

                    if (c) {
                        c["gender"] = genderIncoming
                        c["age"] = getPersonAge(person.NationalRegistry.OrgId)
                    } else {
                        c = defaultCustomer()
                        c.customerId = person.NationalRegistry.OrgId
                        c["gender"] = genderIncoming
                        c["age"] = getPersonAge(person.NationalRegistry.OrgId)
                        c["natRegGender"] = genderIncoming
                    }

                    state.data[person.NationalRegistry.OrgId] = c

                }
            }


            return state

        case infocollectionTypes.REMOVE_KEY:

            state = { ...state }

            let cust = state.data[action.customerId]
            if (cust) {
                if (action.key !== undefined && cust[action.key]) {
                    delete cust[action.key]
                }
            }

            return state

        case infocollectionTypes.REMOVE_BENEFICIARY:

            state = { ...state }

            let _cust = state.data[action.customerId]
            if (_cust) {
                if (action.key !== undefined && _cust[action.key]) {
                    _cust[action.key] = _cust[action.key].filter(f => f !== action.value)
                }
            }

            return state

        default:
            return state
    }
}